import * as React from 'react';
import { SVGProps } from 'react';

const IconExpandSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 5h-8V3h10v10h-2V5zM5 19v-8H3v10h10v-2H5z"
    />
  </svg>
);
export default IconExpandSizeM;
